import type { Metadata } from 'next'
import { LANGUAGES, LANG } from '@/utils'
import type { TypeLang } from '@/schema'

export const buildLangAlternates = ({ lang, pathByLang }: { lang: TypeLang, pathByLang: Record<TypeLang, string> }): Metadata['alternates'] => ({
  canonical: pathByLang[lang],
  languages: {
    ...Object.fromEntries(LANGUAGES.map(l => [l, pathByLang[l]])),
    'x-default': pathByLang[LANG]
  }
})
